import { useMemo } from "react";

export function useRegionDisplayNames(locale: string): Intl.DisplayNames {
  return useMemo(
    () => new Intl.DisplayNames([locale], { type: "region" }),
    [locale],
  );
}
